import React from "react";
import { Tag } from "antd";

import { Modal } from "@components/Page";
import { W1, DRAWER_WIDTH3 } from "@components/Constants";
import { type OrganizationPublicKey } from "@api/types";

import { getAudienceColor, getAudienceLabel } from "./helpers/audiences";
import OrganizationPublicKeyDetails from "./OrganizationPublicKeyDetails";

type Props = {
  publicKey?: OrganizationPublicKey;
  isOpen: boolean;
  onClose: () => void;
};

const OrganizationPublicKeyDetailsModal = ({
  publicKey,
  isOpen,
  onClose,
}: Props): JSX.Element => {
  const hasPublicKey = !!publicKey;

  const audienceLabel = hasPublicKey
    ? getAudienceLabel(publicKey.audience)
    : "";

  const audienceColor = hasPublicKey
    ? getAudienceColor(publicKey.audience)
    : undefined;

  const tagStyle = {
    marginLeft: W1,
  };

  const title = (
    <>
      {publicKey?.name}

      {hasPublicKey && (
        <Tag color={audienceColor} style={tagStyle}>
          {audienceLabel}
        </Tag>
      )}
    </>
  );

  const modalProps = {
    title,
    width: DRAWER_WIDTH3,
    isOpen,
    onClose,
  };

  return (
    <Modal {...modalProps}>
      {hasPublicKey
        ? <OrganizationPublicKeyDetails publicKey={publicKey} />
        : <></>}
    </Modal>
  );
};

export default OrganizationPublicKeyDetailsModal;
